import React, { useState } from "react";
import Button from "../Button";
import Modal from "../Modal";
import InputSelect from "../InputSelect";
import api from "../../services/api";
import { renderError } from "../../helpers/errors";
import { InputXLS } from "../InputXLS";
import { toast } from "react-toastify";

const targetOptions = [
    { label: 'Celular', value: 'phone' },
    { label: 'E-mail', value: 'email' },
];

const companyOptions = [
    { label: 'Atualizar empresa já cadastrada', value: 'save' },
    { label: 'Não fazer nada caso a empresa já esteja cadastrada', value: 'skip' },
];

const customerOptions = [
    { label: 'Atualizar pessoa já cadastrada', value: 'save' },
    { label: 'Não fazer nada caso a pessoa já esteja cadastrada', value: 'skip' },
];

export const ModalImportCompanyClients = ({ show, close, refresh }) => {
    const [loading, setLoading] = useState(false);
    const [company, setCompany] = useState('');
    const [customer, setCustomer] = useState('');
    const [target, setTarget] = useState('');
    const [file, setFile] = useState('');
    const [errorDownloadLink, setErrorDownloadLink] = useState(null);

    const clean = () => {
        setCompany('');
        setCustomer('');
        setTarget('');
        setFile('');
        setErrorDownloadLink(null);
    };

    const getSpreadsheetTemplate = () => {
        setLoading(true);
        api.get(`/company/xlsx`)
            .then(response => {
                window.location.href = response.data.url;
            })
            .catch(error => {
                renderError(error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const getImportErrorData = (fileId) => {
        setLoading(true);
        api.get(`/company/invalid-xlsx/${fileId}`, {
            responseType: 'blob',
        })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'DadosInvalidos.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        })
        .catch(error => {
            renderError(error);
        })
        .finally(() => {
            setLoading(false);
        });
    };

    const storeDatasheet = () => {
        if (!file) {
            toast.error('Por favor, selecione uma planilha.');
            return;
        }

        const formData = new FormData();
        formData.append('company_option', company);
        formData.append('customer_option', customer);
        formData.append('target', target);
        formData.append('file', file);

        setLoading(true);
        api.post(`/company/xlsx`, formData)
            .then(res => {
                toast.success('Planilha enviada com sucesso');
                clean();
                close();
            })
            .catch(error => {
                renderError(error);
                if (error.response?.data?.download_link) {
                    setErrorDownloadLink(error.response.data.download_link);
                }
            })
            .finally(() => {
                refresh();
                setLoading(false);
            });
    };

    return (
        <Modal
            title={`Importar empresas`}
            show={show}
            close={close}
            footer={
                <Button
                    type={`primary`}
                    size={`small`}
                    text={`Enviar`}
                    svg={`save-white`}
                    action={storeDatasheet}
                    loading={loading}
                />
            }
        >
            <div className="section">
                <div className="row mb-3">
                    <div className="col-12">
                        <Button
                            type={`primary`}
                            text={`Planilha Modelo`}
                            svg={`export`}
                            full={true}
                            action={getSpreadsheetTemplate}
                            loading={loading}
                        />
                    </div>
                </div>
                <div className="row align-items-center">
                    <div className="col-6">
                        <InputSelect
                            label={`Ação Empresa`}
                            options={companyOptions}
                            value={company}
                            change={setCompany}
                        />
                    </div>
                    <div className="col-6 d-flex flex-column justify-content-center text-start" style={{ marginTop: -12 }}>
                        <p className="mb-1" style={{ marginBottom: 8 }}>Campo de referência: <strong>CNPJ</strong></p>
                        <p style={{ fontSize: '0.75rem', fontStyle: 'italic', margin: 0, lineHeight: 1.3 }}>
                            Se não tiver CNPJ, a empresa será cadastrada como nova.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <InputSelect
                            label={`Ação Pessoa`}
                            options={customerOptions}
                            value={customer}
                            change={setCustomer}
                        />
                    </div>
                    <div className="col-6">
                        <InputSelect
                            isDisabled={!customer || customer === 'skip'}
                            label={`Selecionar por`}
                            options={targetOptions}
                            value={target}
                            change={setTarget}
                        />
                    </div>               
                </div>
                <div className="row">
                    <div className="col-12">
                        <p className="mb-2 text-muted" style={{ textAlign: 'right', marginInlineEnd: 3, fontStyle: 'italic' }}><span style={{ color: 'red' }}>*</span> Limite de <strong>2 Mil</strong> linhas por arquivo</p>
                        <InputXLS
                            label={`Planilha`}
                            file={file}
                            changeFile={setFile}
                        />
                    </div>
                </div>
            </div>
            {errorDownloadLink && (
                <div className="section">
                    <div className="row mb-3">
                        <div className="col-6 mx-auto">
                            <p style={{ marginTop: 7, color: 'green'}}>Os dados <strong>não listados</strong> nesta planilha foram importados <strong>com sucesso.</strong></p>
                        </div>
                        <div className="col-6 mx-auto">
                            <Button
                                type={`secondary`}
                                text={`Planilha com dados não salvos`}
                                style={{ 
                                    textAlign: "center",
                                    border: "2px solid #b91c1c",
                                    color: "#ffffff",
                                    backgroundColor: "#b91c1c",
                                }}
                                svg={`export`}
                                full={true}
                                action={() => getImportErrorData(errorDownloadLink)}
                                loading={false}
                            />
                        </div>
                    </div>
                </div>
            )}
        </Modal>
    );
};

export default Modal;
